import LottoNav from "../LottoNav";
import {lottoMenus} from "../../constants/nav";
import React from "react";


const Lotto5Nav = () => <LottoNav menus={lottoMenus('lottery5')}/>

export default Lotto5Nav;